import React from 'react';
import { availabilityBadge } from './availability';

export default function HeroCard({ engineer, score, whyMatch, turnKey, onOpenDossier }) {
  if (!engineer) {
    return (
      <div className="hero-card">
        <div className="hero-card__inner">
          <div className="hero-card__foil" />
          <div className="hero-card__top">
            <span>⚡ HUMANAIZE MATCHER</span>
            <span className="hero-card__hp">STANDBY</span>
          </div>
          <div className="hero-card__empty">
            Vertel waar je iemand voor zoekt — de matcher luistert mee.
          </div>
        </div>
      </div>
    );
  }

  const stars = engineer.stars ? '★'.repeat(engineer.stars) + '☆'.repeat(5 - engineer.stars) : '';
  const cardNumber = (engineer.id || '').slice(0, 3).toUpperCase();
  const avail = availabilityBadge(engineer.beschikbaarheid);

  return (
    <div className="hero-card">
      <div className="hero-card__inner">
        <div className="hero-card__foil" />
        <div className="hero-card__top">
          <span>⚡ HUMANAIZE TCG · #{cardNumber}</span>
          <span className="hero-card__hp">HP {engineer.hp ?? '—'}</span>
        </div>

        <div className="hero-card__name-row">
          <span className="hero-card__name">{engineer.name?.split(' ')[0]?.toUpperCase()}</span>
          <span className="hero-card__stars">{stars} · match {typeof score === 'number' ? `${score}%` : '—'}</span>
          {avail && (
            <span className={`avail-badge avail-badge--${avail.statusKey}`} title={avail.title}>● {avail.label}</span>
          )}
        </div>

        <div className="hero-card__photo-wrap">
          <div className="hero-card__photo-inner">
            {engineer.photo
              ? <img src={engineer.photo} alt={engineer.name} />
              : <span className="hero-card__photo-placeholder">[ FOTO ]</span>}
            <div className="hero-card__role-strip">{engineer.role?.toUpperCase()}</div>
          </div>
        </div>

        <div className="hero-card__section-label">SIGNATURE ABILITIES</div>
        {(engineer.signatureAbilities || []).slice(0, 2).map((a, i) => (
          <div key={i} className="hero-card__ability">
            <span>{a.emoji}</span>
            <span>{a.name?.toUpperCase()}</span>
            <span className="dmg">+{a.damage}</span>
          </div>
        ))}

        <div className="hero-card__why" key={turnKey}>
          <div className="hero-card__why-label">WAAROM PAST — LIVE</div>
          {(whyMatch && whyMatch.length > 0) ? (
            whyMatch.slice(0, 3).map((w, i) => (
              <div key={i} className="hero-card__why-line">
                <span className="hero-card__why-quote">&ldquo;{w.quote}&rdquo;</span>
                {' → '}
                {w.evidence}
              </div>
            ))
          ) : (
            <div className="hero-card__why-line" style={{ color: 'var(--hai-muted)', fontStyle: 'italic' }}>
              Verzamel meer informatie voor concrete match-redenen…
            </div>
          )}
        </div>

        {onOpenDossier && (
          <button
            type="button"
            className="hero-card__dossier-btn"
            onClick={onOpenDossier}
            aria-label={`Bekijk volledig dossier van ${engineer.name}`}
          >
            Bekijk volledig dossier <span aria-hidden="true">→</span>
          </button>
        )}
      </div>
    </div>
  );
}
